<template>
  <div>
    <el-select
      v-model="myCity"
      filterable
      clearable
      :disabled="disabled ? true : false"
      :placeholder="placeholder"
      @change="$event => $emit('input',$event)"
    >
      <el-option
        v-for="item in citys"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      >
      </el-option>
    </el-select>
  </div>
</template>

<script>

export default {
    name: 'wCity',
    props: {
        value: [String,Number],
        placeholder: {
            default: '请选择城市'
        },
        defaultUrl: [String ,Boolean],
        disabled: [String ,Boolean],
    },
    data(){
        return {
            myCity: this.value,
            citys: [],
        }
    },
    watch: {
        value(val){
            this.myCity = val
        }
    },
    created(){
        this.getCityOptions()
    },
    methods: {
        qq(e){
            // console.log(e)
        },
        async getCityOptions() {
        this.$http.post(this.defaultUrl).then(({ data: res }) => {
            if (res.code !== 0) {
                return this.$message.error(res.msg)
            }
            // console.log(res.data)
            this.citys=[];
            if (res.data!=null){
                res.data.forEach(element => {
                    this.citys.push({label:element,value:element})
                })
               
            }
        }).catch(() => {})
    },
    }
};
</script>

<style>
</style>